module.exports = __webpack_public_path__ + "static/media/time tracking 5.d1a759e2.svg";